import {React, useState, useContext} from 'react';
import {Grid, Box, Button, Paper, Stack, createTheme, ThemeProvider, Typography} from '@mui/material';
import { FaRupeeSign, FaUmbrellaBeach } from "react-icons/fa";
import { BsFilePerson } from "react-icons/bs";
import Popup from '../Popup';
import AddEmployeeForm from './AddEmployeeForm';
import ViewEmpSalComponents from './ViewEmpSalComponents';
import ViewEmployeeStipend from './ViewEmployeeStipend';
import ViewEmployeeLeaves from './ViewEmployeeLeaves';
import ViewEarningComponents from './ViewEarningComponents';
import ViewDeductionComponents from './ViewDeductionComponents';
import { EmpNameContext } from '../table-data/EmployeeMasterTable';

const title_text = '';

function handleClick(event){
  alert(event.currentTarget.id)
}

function EmployeeModifyOptions(props){
  const context = useContext(EmpNameContext);

  const [values, setValues] = useState();
  const [openPopup1, setOpenPopup1] = useState(false);
  const [openPopup2, setOpenPopup2] = useState(false);
  const [openPopup3, setOpenPopup3] = useState(false);
  const [openPopup4, setOpenPopup4] = useState(false);
  const [openPopup5, setOpenPopup5] = useState(false);
  const [openStipendPopup, setOpenStipendPopup] = useState(false);

   const handleClosePersonalDataModal = () => {
    setOpenPopup1(false);
    if (props.onUpdated) props.onUpdated();
  };

  const theme = createTheme({
    palette: {
      primary: { main: '#0b418e' },
      danger: {
        main: '#ffeb3b',
      },
      orange: {
        main: '#ff5722',
      },
      blueGrey: {
        main: '#607d8b',
      },
      lightGreen: {
        main: '#94B49F',
      },
      pink: {
        main: '#ec407a',
      },
      purple: {
        main: '#ab47bc',
      },
      lightRed: {
        main: '#FA7070',
      },
      lightYellow: {
        main: '#CCD6A6',
      },
      lightBlue: {
        main: '#8CC0DE',
      },
      color1: {
        main: '#CFB997',
      },
      color2: {
        main: '#C85C8E'
      },
    },
  });


  return(
    <ThemeProvider theme={theme}>
    <Paper sx={{backgroundColor: "#344D67"}} >
    <Box className="master-button-container">
      {/* <Typography variant="h4" sx={{textAlign: "center", marginBottom: "20px"}}>{props.title}</Typography> */}

        
          <Grid container  spacing={2}>
          <Stack spacing={3}>
            {!context.isInternApprentice && (
              <>
                <Stack direction='row' style={{'margin-left': '25px'}}>
                  <Grid item>
                    <Box width="100px"> 
                      <Button className="option-btn" variant="contained" color="lightRed" onClick={() => setOpenPopup1(true)} startIcon={<BsFilePerson size="50px" color="white"/>}>   </Button>
                      <Typography variant="h6" color="white" sx={{fontWeight: "300"}} >Personal Data</Typography> 
                    </Box>
                  </Grid>
                  <Grid item>
                    <Box width="100px"> 
                      <Button className="option-btn" variant="contained" color="lightBlue" onClick={() => setOpenPopup2(true)} startIcon={<FaRupeeSign size="50px" color="white" />}></Button>
                      <Typography variant="h6" color="white" sx={{fontWeight: "300"}}>Employee Salary</Typography>
                    </Box>
                  </Grid>
                  <Grid item>
                    <Box width="100px"> 
                      <Button className="option-btn" variant="contained" color="lightGreen" onClick={() => setOpenPopup3(true)} startIcon={<FaUmbrellaBeach size="50px" color="white"/>}></Button>
                      <Typography variant="h6" color="white" sx={{fontWeight: "300"}}>Leave Data</Typography>
                    </Box>
                  </Grid>
                </Stack>
                <Stack direction='row' style={{"justify-content": "center"}}>
                  <Grid item>
                    <Box width="100px"> 
                      <Button className="option-btn" variant="contained" color="color1" onClick={() => setOpenPopup4(true)} startIcon={<FaUmbrellaBeach size="50px" color="white"/>}></Button>
                      <Typography variant="h6" color="white" sx={{fontWeight: "300"}}>Earning</Typography>
                    </Box>
                  </Grid>
                  <Grid item>
                    <Box width="100px"> 
                      <Button className="option-btn" variant="contained" color="color2" onClick={() => setOpenPopup5(true)} startIcon={<FaUmbrellaBeach size="50px" color="white"/>}></Button>
                      <Typography variant="h6" color="white" sx={{fontWeight: "300"}}>Deduction</Typography>
                    </Box>
                  </Grid>
                </Stack>
              </>
            )}

            {context.isInternApprentice && (
              <Stack direction='row' style={{'margin-left': '25px'}}>
                <Grid item>
                  <Box width="100px"> 
                    <Button className="option-btn" variant="contained" color="lightRed" onClick={() => setOpenPopup1(true)} startIcon={<BsFilePerson size="50px" color="white"/>}>   </Button>
                    <Typography variant="h6" color="white" sx={{fontWeight: "300"}} >Personal Data</Typography> 
                  </Box>
                </Grid>
                <Grid item>
                  <Box width="130px"> 
                    <Button className="option-btn" variant="contained" color="lightBlue" onClick={() => setOpenStipendPopup(true)} startIcon={<FaRupeeSign size="50px" color="white" />}></Button>
                    <Typography variant="h6" color="white" sx={{fontWeight: "300"}}> Intern/Apprentice Stipend</Typography>
                  </Box>
                </Grid>
              </Stack>
            )}
          </Stack>
          </Grid>

    </Box>
    </Paper>
    <Popup
        title={"Personal Data - " + context.fName + ' ' + context.lName}
        openPopup={openPopup1}
        setOpenPopup={setOpenPopup1}
      >
        <AddEmployeeForm
          fetch_id={props.fetch_id}
          onCloseModal={handleClosePersonalDataModal}
          hideStatutory={!!context?.isInternApprentice}
        />
      </Popup>
      <Popup
        title={"Salary Data - " + context.fName + ' ' + context.lName}
        openPopup={openPopup2}
        setOpenPopup={setOpenPopup2}
      >
        <ViewEmpSalComponents fetch_id={props.fetch_id} />
      </Popup>
      <Popup
        title={"Stipend Data - " + context.fName + ' ' + context.lName}
        openPopup={openStipendPopup}
        setOpenPopup={setOpenStipendPopup}
      >
        <ViewEmployeeStipend fetch_id={props.fetch_id} />
      </Popup>
      <Popup
        title={"Leave Data - " + context.fName + ' ' + context.lName}
        openPopup={openPopup3}
        setOpenPopup={setOpenPopup3}
      >
        <ViewEmployeeLeaves fetch_id={props.fetch_id} />
      </Popup>
      <Popup
        title={"Earning Components - " + context.fName + ' ' + context.lName}
        openPopup={openPopup4}
        setOpenPopup={setOpenPopup4}
      >
        <ViewEarningComponents fetch_id={props.fetch_id} />
      </Popup>
      <Popup
        title={"Deduction Components - " + context.fName + ' ' + context.lName}
        openPopup={openPopup5}
        setOpenPopup={setOpenPopup5}
      >
        <ViewDeductionComponents fetch_id={props.fetch_id} />
      </Popup>
    </ThemeProvider>
  )
}

export default EmployeeModifyOptions;
